var _defs, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreySeaWeapons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "revolver-cylinder-scallop",
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "revolver-bullet",
    r: 1.3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "revolver-edge-scallops"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 10,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-cylinder-scallop",
    transform: "rotate(0) translate(0, 6.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-cylinder-scallop",
    transform: "rotate(72) translate(0, 6.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-cylinder-scallop",
    transform: "rotate(144) translate(0, 6.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-cylinder-scallop",
    transform: "rotate(216) translate(0, 6.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-cylinder-scallop",
    transform: "rotate(288) translate(0, 6.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-bullet",
    transform: "rotate(0) translate(0, -3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-bullet",
    transform: "rotate(72) translate(0, -3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-bullet",
    transform: "rotate(144) translate(0, -3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-bullet",
    transform: "rotate(216) translate(0, -3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revolver-bullet",
    transform: "rotate(288) translate(0, -3)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.6
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.4,
    transform: "rotate(72) translate(0, -3)",
    fill: "#ffd000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    mask: "url(#revolver-edge-scallops)",
    fill: "#777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySeaWeapons);
export default __webpack_public_path__ + "static/media/grey-sea-weapons.c163cc48470e69dbc87e4c002c298eaa.svg";
export { ForwardRef as ReactComponent };